import { render, staticRenderFns } from "./InspectionItemTab.vue?vue&type=template&id=02ee2dce&scoped=true"
import script from "./InspectionItemTab.vue?vue&type=script&lang=js"
export * from "./InspectionItemTab.vue?vue&type=script&lang=js"
import style0 from "./InspectionItemTab.vue?vue&type=style&index=0&id=02ee2dce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ee2dce",
  null
  
)

export default component.exports